import React from 'react';
import classes from './AboutMe.module.css';
import Vector from '../../assets/vector.svg';
import SmallPinkVector from '../../assets/small-pink-vector.svg';

function AboutMe() {
	return (
		<div className={classes.AboutMe}>
			<div className={classes.BioSkillsContainer}>
				<div className={classes.Bio}>

					<p>
						Hi, I'm Olesia!</p>
						<p>I am a Support Engineer based out of NYC, currently at Monte Carlo, <br /> where I help customers with data and AI observability. {' '}
					</p>
				<p>I work a lot with SQL, Python, logs, and AI-native tooling to help customers get the most out of their data pipelines.</p>
				<p>Outside of work I'm a dog mom, a Peloton regular, and someone who reads across pretty much every genre.</p>
				</div>

			</div>
			<h2>Education:</h2>
			<div className={classes.Education}>
				<div>
					{' '}
					AS in Applied Math
					<br /> <img src={Vector} alt=' ' />
					<br />
					<strong>LaGuardia Community College</strong> <br />
					<span>
						<img src={SmallPinkVector} alt=' ' />
						<i>Queens, NY</i>
					</span>
				</div>

				<br />
				<div>
					Certificate In Web Development
					<br /> <img src={Vector} alt=' ' />
					<br />
					<strong>Fullstack Academy</strong> <br />
					<span>
						<img src={SmallPinkVector} alt=' ' />
						<i>New York, NY</i>
					</span>
				</div>
			</div>
		</div>
	);
}

export default AboutMe;
